import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService} from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
 import { ActiveSessionComponent } from './active-session.component';
import { ActiveSessionRoutingModule } from './active-session-routing.module';

@NgModule({
  declarations: [
    ActiveSessionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    GridModule,
    ReactiveFormsModule,
    ActiveSessionRoutingModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule
  ],
  providers: [ColumnChooserService,PageService,SortService,FilterService,ResizeService],
})
export class ActiveSessionModule { }
